export const CLEAR_QUESTION = 'CLEAR_QUESTION';
export const CLEAR_QUESTIONS = 'CLEAR_QUESTIONS';

// export const DELETE_COOWNER = 'DELETE_COOWNER';
// export const DELETE_COOWNER_ERROR = 'DELETE_COOWNER_ERROR';
// export const DELETE_COOWNER_SUCCESS = 'DELETE_COOWNER_SUCCESS';

export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_QUESTIONS_ERROR = 'GET_QUESTIONS_ERROR';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';

export const GET_QUESTION = 'GET_QUESTION';
export const GET_QUESTION_ERROR = 'GET_QUESTION_ERROR';
export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';

export const SAVE_QUESTION = 'SAVE_QUESTION';
export const SAVE_QUESTION_ERROR = 'SAVE_QUESTION_ERROR';
export const SAVE_QUESTION_SUCCESS = 'SAVE_QUESTION_SUCCESS';

export const ADD_QUESTION = 'ADD_QUESTION';
export const ADD_QUESTION_ERROR = 'ADD_QUESTION_ERROR';
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS';

export const MAIN_ANSWER = 'MAIN_ANSWER_QUESTION';
export const MAIN_ANSWER_ERROR = 'MAIN_ANSWER_ERROR';
export const MAIN_ANSWER_SUCCESS = 'MAIN_ANSWER_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Forum/constants.js